import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { StyledActionIcon } from "src/styled";

export const BackButton = ({ onClick }: { onClick?: () => void }) => {
  const navigate = useNavigate();

  return (
    <StyledActionIcon
      data-cy="back-button"
      size="lg"
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          navigate(-1);
        }
      }}>
      <IconChevronLeft size="1.5rem" />
    </StyledActionIcon>
  );
};
